<template>
    <span :endTime="endTime" :endText="endText">
        <slot>
            {{content}}
        </slot>
    </span>
</template>
<script>
export default {
    name: 'CountDown', // 倒计时
    data(){
        return {
            content: '',
            timer: ''
        }
    },
    props:{
        endTime:{
            type: String,
            default :''
        },
        endText:{
            type : String,
            default:'已结束'
        },
    },
    watch: {
        endTime() {
            this.countdowm(this.endTime)
        }
    },
    mounted () {
        this.countdowm(this.endTime)
    },
    methods: {
        countdowm(timestamp){
            this.timer = setInterval(()=>{
                let nowTime = new Date()
                let t = timestamp - nowTime.getTime()
                if(t > 0){
                    let hour=Math.floor((t/3600000)%24)
                    let min=Math.floor((t/60000)%60)
                    let sec=Math.floor((t/1000)%60)
                    hour = hour < 10 ? "0" + hour : hour
                    min = min < 10 ? "0" + min : min
                    sec = sec < 10 ? "0" + sec : sec
                    let format = ''
                    if(hour > 0 ){
                        format = `${hour}:${min}:${sec}`
                    }
                    if(hour <= 0){
                        format =`${min}:${sec}`
                    }
                    this.content = format
                    // console.log(this.content)
                }else{
                    clearInterval(this.timer)
                    this.content = this.endText
                    this.$emit('examendChange')
                }
            },1000);
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    }
}
</script>